<div id="kt_brand" class="brand flex-column-auto" kt-hidden-height="65">
    <a routerLink="/" target="_blank" class="brand-logo">
        <img *ngIf="!appSession.tenant || !appSession.tenant.logoId" src="/assets/common/images/ITP-copilot logo.svg" alt="logo" height="30" width="195"  />
     <!--   <img *ngIf="appSession.tenant && appSession.tenant.logoId"
            [src]="remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=' + currentTheme.baseSettings.menu.asideSkin + '&tenantId=' + appSession.tenant.id + '&id=' + appSession.tenant.logoId"
            alt="logo" height="38" />-->

    </a>
    <a class="minimize-logo-brand pl-3">
        <img *ngIf="!appSession.tenant || !appSession.tenant.logoId" src="/assets/common/images/ITP_Collapsed_Logo.svg" alt="logo" height="25" width="25" />
    </a>
    <!-- <button class="brand-toggle btn btn-sm px-0 border-0 custom-style-logo-icon" id="kt_aside_toggle" id="kt_aside_toggler"
        *ngIf="currentTheme.baseSettings.menu.allowAsideMinimizing" (click)="toggleLeftAside()">
        <span class="svg-icon svg-icon svg-icon-xl">
            <img *ngIf="isCollapsed" src="/assets/common/images/Expand.svg" alt="logo" height="24"  />
            <img *ngIf="!isCollapsed" src="/assets/common/images/Collapse.svg" alt="logo" height="24"  />

        </span>
    </button> -->
</div>
